import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { NotificatoinsAndMessagesDropdownComponent } from '../notificatoins-and-messages-dropdown/notificatoins-and-messages-dropdown.component';
import {
  NotifsAndMessagesService,
  NotificationsResponse,
  MessagesResponse,
} from '../notificatoins-and-messages-dropdown/notifs-and-messages.service';
import { CommonModule } from '@angular/common';
import { Popover } from 'primeng/popover';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { NavBarService } from '../nav-bar.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideUser,
  lucideBuilding,
  lucideBuilding2,
  lucidePhone,
  lucideLamp,
} from '@ng-icons/lucide';
import { BadgeModule } from 'primeng/badge';
import { DividerModule } from 'primeng/divider';
import { AuthModule } from 'src/app/features/auth/auth.module';

@Component({
  selector: 'app-navbar',
  imports: [
    ButtonModule,
    CommonModule,
    NotificatoinsAndMessagesDropdownComponent,
    Popover,
    BadgeModule,
    OverlayBadgeModule,
    DividerModule,
    AuthModule,
  ],
  viewProviders: [
    provideIcons({
      lucideUser,
      lucideBuilding,
      lucideBuilding2,
      lucidePhone,
    }),
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit {
  navBarService = inject(NavBarService);
  notifications = signal<NotificationsResponse>({
    results: [],
    count: 0,
    extra: { unseen_notifications_count: 0 },
  });
  messages = signal<MessagesResponse>({
    count: 0,
    results: [],
    extra: { unseen_messages_count: 0 },
  });

  hasUnseenNotifMessageCount = signal(0);

  @ViewChild('notificationsPopover') popover!: Popover;

  constructor(private notifsService: NotifsAndMessagesService) {
    effect(() => {
      this.hasUnseenNotifMessageCount.set(
        (this.notifications().extra.unseen_notifications_count ?? 0) +
          (this.messages().extra.unseen_messages_count ?? 0),
      );
    });
  }
  avatarUrl = signal<string>('');
  private imageSubscription: Subscription | null = null;

  ngOnInit() {
    this.fetchNotificationsAndMessages();
  }
  ngOnDestroy() {
    if (this.imageSubscription) {
      this.imageSubscription.unsubscribe();
    }
  }

  fetchNotificationsAndMessages() {
    // Fetch notifications
    this.notifsService.getNotifications().subscribe((data: any) => {
      this.notifications.set(data);
    });

    // Fetch messages
    this.notifsService.getMessages().subscribe((data: any) => {
      this.messages.set(data);
    });
  }

  toggleNotificationsDropdown($event: Event) {
    this.popover.toggle($event);
  }
  onNotificationsChange(data: NotificationsResponse) {
    this.notifications.set(data);
    this.hasUnseenNotifMessageCount.set(
      (this.notifications().extra.unseen_notifications_count ?? 0) +
        (this.messages().extra.unseen_messages_count ?? 0),
    );
  }
  onMessagesChange(data: MessagesResponse) {
    this.messages.set(data);
    this.hasUnseenNotifMessageCount.set(
      (this.notifications().extra.unseen_notifications_count ?? 0) +
        (this.messages().extra.unseen_messages_count ?? 0),
    );
  }
}
